export const PRO_KNOWN_FILES = 'PRO_KNOWN_FILES'
export const PLOTTR_KNOWN_FILES = 'PLOTTR_KNOWN_FILES'
